import axios from 'axios'
import { Message } from 'element-ui'

const api = axios.create({ baseURL: '/api', timeout: 15000 })

api.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  // 机构管理员自动附加 org_code（即使 API 没传 params 也会加上）
  const orgCode = localStorage.getItem('admin_org_code')
  if (orgCode) {
    config.params = config.params || {}
    if (!config.params.org_code) config.params.org_code = orgCode
  }
  return config
})

api.interceptors.response.use(
  res => {
    const data = res.data
    if (data.code === 401) {
      localStorage.removeItem('admin_token')
      window.location.hash = '#/login'
      return Promise.reject(new Error('登录已过期'))
    }
    return data
  },
  err => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('admin_token')
      window.location.hash = '#/login'
    }
    return Promise.reject(err)
  }
)

// ==================== Auth ====================
export function login(data) { return api.post('/auth/login', data) }

// ==================== Dashboard ====================
export function getStats(params) { return api.get('/admin/stats', { params }) }

// ==================== Users ====================
export function getUsers(params) { return api.get('/admin/users', { params }) }
export function updateUser(id, data) { return api.put(`/admin/users/${id}`, data) }
export function deleteUser(id) { return api.delete(`/admin/users/${id}`) }

// ==================== Rooms ====================
export function getRooms(params) { return api.get('/admin/rooms', { params }) }
export function updateRoom(id, data) { return api.put(`/admin/rooms/${id}`, data) }
export function deleteRoom(id) { return api.delete(`/admin/rooms/${id}`) }

// ==================== Gifts ====================
export function getGifts(params) { return api.get('/admin/gifts', { params }) }
export function createGift(data) { return api.post('/admin/gifts', data) }
export function updateGift(id, data) { return api.put(`/admin/gifts/${id}`, data) }
export function deleteGift(id) { return api.delete(`/admin/gifts/${id}`) }

// ==================== Decorations ====================
export function getDecorations(params) { return api.get('/admin/decorations', { params }) }
export function createDecoration(data) { return api.post('/admin/decorations', data) }
export function updateDecoration(id, data) { return api.put(`/admin/decorations/${id}`, data) }
export function deleteDecoration(id) { return api.delete(`/admin/decorations/${id}`) }

// ==================== VIP Tiers ====================
export function getVipTiers(params) { return api.get('/admin/vip-tiers', { params }) }
export function createVipTier(data) { return api.post('/admin/vip-tiers', data) }
export function updateVipTier(id, data) { return api.put(`/admin/vip-tiers/${id}`, data) }
export function deleteVipTier(id) { return api.delete(`/admin/vip-tiers/${id}`) }

// ==================== VIP Privileges ====================
export function getVipPrivileges(params) { return api.get('/admin/vip-privileges', { params }) }
export function createVipPrivilege(data) { return api.post('/admin/vip-privileges', data) }
export function updateVipPrivilege(id, data) { return api.put(`/admin/vip-privileges/${id}`, data) }
export function deleteVipPrivilege(id) { return api.delete(`/admin/vip-privileges/${id}`) }

// ==================== Emojis ====================
export function getEmojis(params) { return api.get('/admin/emojis', { params }) }
export function createEmoji(data) { return api.post('/admin/emojis', data) }
export function updateEmoji(id, data) { return api.put(`/admin/emojis/${id}`, data) }
export function deleteEmoji(id) { return api.delete(`/admin/emojis/${id}`) }

// ==================== Room Tags ====================
export function getRoomTags() { return api.get('/admin/room-tags') }
export function createRoomTag(data) { return api.post('/admin/room-tags', data) }
export function updateRoomTag(id, data) { return api.put(`/admin/room-tags/${id}`, data) }
export function deleteRoomTag(id) { return api.delete(`/admin/room-tags/${id}`) }

// ==================== Theme Parties ====================
export function getThemeParties() { return api.get('/admin/theme-parties') }
export function createThemeParty(data) { return api.post('/admin/theme-parties', data) }
export function updateThemeParty(id, data) { return api.put(`/admin/theme-parties/${id}`, data) }
export function deleteThemeParty(id) { return api.delete(`/admin/theme-parties/${id}`) }

// ==================== Guilds ====================
export function getGuilds(params) { return api.get('/admin/guilds', { params }) }
export function getGuildMembers(guildId) { return api.get('/admin/guild-members', { params: { guildId } }) }
export function updateGuild(id, data) { return api.put(`/admin/guilds/${id}`, data) }
export function deleteGuild(id) { return api.delete(`/admin/guilds/${id}`) }
export function updateGuildMember(memberId, data) { return api.put(`/admin/guild-members/${memberId}`, data) }

// ==================== Rank ====================
export function getRankList(params) { return api.get('/admin/rank-list', { params }) }
export function createRankItem(data) { return api.post('/admin/rank-list', data) }
export function updateRankItem(id, data) { return api.put(`/admin/rank-list/${id}`, data) }
export function deleteRankItem(id) { return api.delete(`/admin/rank-list/${id}`) }
export function getHourRank() { return api.get('/admin/hour-rank') }
export function createHourRankItem(data) { return api.post('/admin/hour-rank', data) }
export function updateHourRankItem(id, data) { return api.put(`/admin/hour-rank/${id}`, data) }
export function deleteHourRankItem(id) { return api.delete(`/admin/hour-rank/${id}`) }

// ==================== Logs ====================
export function getRechargeLogs(params) { return api.get('/admin/recharge-logs', { params }) }
export function getGiftLogs(params) { return api.get('/admin/gift-logs', { params }) }
export function getConsumptionLogs(params) { return api.get('/admin/consumption-logs', { params }) }

// ==================== Settings ====================
export function getSettings(key) { return api.get('/admin/settings', { params: key ? { key } : {} }) }
export function getAllSettings() { return api.get('/admin/settings-all') }
export function updateSetting(key, value) { return api.put('/admin/settings', { key, value }) }
export function createSetting(data) { return api.post('/admin/settings', data) }

// ==================== Organization Management ====================
export function getOrganizations(params) { return api.get('/admin/organizations', { params }) }
export function createOrganization(data) { return api.post('/admin/organizations', data) }
export function updateOrganization(id, data) { return api.put(`/admin/organizations/${id}`, data) }
export function deleteOrganization(id) { return api.delete(`/admin/organizations/${id}`) }
export function getOrgAdmins(params) { return api.get('/admin/org-admins', { params }) }
export function addOrgAdmin(data) { return api.post('/admin/org-admins', data) }
export function removeOrgAdmin(id) { return api.delete(`/admin/org-admins/${id}`) }

// ==================== My Org Info ====================
export function getMyOrg() { return api.get('/admin/my-org') }

// ==================== Payment Config ====================
export function getPaymentConfig() { return api.get('/admin/payment/config') }
export function updatePaymentConfig(config) { return api.put('/admin/payment/config', { config }) }

// ==================== Withdrawal Management ====================
export function getWithdrawLogs(params) { return api.get('/admin/withdraw-logs', { params }) }
export function approveWithdraw(id, data) { return api.put(`/admin/withdraw/${id}/approve`, data || {}) }
export function rejectWithdraw(id, data) { return api.put(`/admin/withdraw/${id}/reject`, data) }
export function payWithdraw(id) { return api.put(`/admin/withdraw/${id}/pay`) }
export function batchPayWithdraw(ids) { return api.post('/admin/withdraw/batch-pay', { ids }) }

// ==================== Finance Report ====================
export function getFinanceReport(params) { return api.get('/admin/finance/report', { params }) }

// ==================== Org Reward Rules ====================
export function getRewardRules(params) { return api.get('/admin/org-reward-rules', { params }) }
export function createRewardRule(data) { return api.post('/admin/org-reward-rules', data) }
export function updateRewardRule(id, data) { return api.put(`/admin/org-reward-rules/${id}`, data) }
export function deleteRewardRule(id) { return api.delete(`/admin/org-reward-rules/${id}`) }

// ==================== Referral Logs ====================
export function getReferralLogs(params) { return api.get('/admin/org-referral-logs', { params }) }

// ==================== Init Reward Rules ====================
export function initRewardRules(data) { return api.post('/admin/org-reward-rules/init', data) }

export default api
